import { api } from '@/lib/api'
import type { JePayload, JeSummary, JournalEntry } from './types'

export const journalEntryApi = {
  list: () => api.get<JeSummary[]>('/api/journal-entries/'),
  nextNumber: () => api.get<{ entryNumber: string }>('/api/journal-entries/next-number'),
  get: (id: number) => api.get<JournalEntry>(`/api/journal-entries/${id}`),
  create: (body: JePayload) => api.post<{ id: number; message?: string }>('/api/journal-entries/', body),
  update: (id: number, body: JePayload) =>
    api.put<{ id?: number; message?: string }>(`/api/journal-entries/${id}`, body),
  post: (id: number) => api.post<{ message?: string }>(`/api/journal-entries/${id}/post`),
  remove: (id: number) => api.del<{ message?: string }>(`/api/journal-entries/${id}`),
}
